module.exports = __webpack_public_path__ + "static/quantum-c9a8b0f5b9cfabf425846b153d27e434.jpg";